import CollectionsCard from './CollectionsCard'

export { Action, FooterAction } from './CollectionsCard'

export type { Item } from './CollectionsCard'

export default CollectionsCard
